import { ListaDiccionaryEntity } from "./lista_diccionary_entity";

export class ViviendaEntity {
    constructor(
        public CodVivienda?: number,
        public TipoEstructura?: string,
        public CodTipoEstructura?: number,
        public CodCliente?: number,
        public CiuCod?: number,
        public CodProducto?: number,
        public CodAseguradora?: number,
        public Poliza?: string,
        public InicioVigencia?: Date,
        public FinVigencia?: Date,
        public DirCallePrincipal?: string,
        public DirNumeracion?: string,
        public DirCalleSecundaria?: string,
        public TieneCertificado?: number,
        public ValorAsegurado?: number,
        public CodUnidad?: number,
        public Opciones?: ListaDiccionaryEntity[],
        public PlanCod?: number,
        public NombreProducto?: string,
        public DireccionAsegurada?: string,
        public NombreAseguradora?: string,
        public Accion?: number,
        public Cancelar?: number,        
        public Renovar?: number,
        public EstadoSolicitud?: number     
    ) { }
}


// WEBPACK FOOTER //
// C:/Fuentes Git/TecnienLineaV2.0/front-consulta-en-linea/src/app/views/masivos/datosGenerales/entities/vivienda_entity.ts